import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_PAYMENT_METHOD } from "helpers/api_endpoints";

function RemovePaymentMethod() {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_PAYMENT_METHOD, { id })
            .then(response => {
                navigate('/payment-methods', { state: { successMsg: 'Payment Method Deleted Successfully' } });
            })
            .catch(error => {
                console.log(error);
            })
    });

    return <React.Fragment>Removed</React.Fragment>;
}

export default withRouter(RemovePaymentMethod)